import { type MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Tooltip, Typography } from '@mui/material';

import { Button } from '@occc-app/design-system';
import { pluralize } from '@occc-app/lib/strings';

import { routeCreator } from '../../retailer-connect.utils';

type LocationGroupHeaderProps = {
  groupName: string;
  groupUuid: string;
  isOthers: boolean;
  storeCount: number | null;
  offlineCount: number;
  networkId: string;
};

export const LocationGroupHeader = ({
  groupName,
  groupUuid,
  isOthers,
  storeCount,
  offlineCount,
  networkId,
}: LocationGroupHeaderProps) => {
  const navigate = useNavigate();

  const handleViewDetails = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    navigate(routeCreator.locationGroupDetails(networkId, groupUuid));
  };

  return (
    <>
      <Box display='flex' alignItems='center' gap={1} flex={1} minWidth={0}>
        <Box display='flex' alignItems='center' gap={0.5} flexShrink={0}>
          <Tooltip title={groupName} placement='top' disableHoverListener={groupName.length <= 30}>
            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 500,
                color: 'text.primary',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: 240,
              }}
            >
              {groupName}
            </Typography>
          </Tooltip>
          {storeCount !== null && (
            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 400,
                color: 'text.primary',
                opacity: 0.7,
                whiteSpace: 'nowrap',
              }}
            >
              • {storeCount} {pluralize(storeCount, 'Store')}
            </Typography>
          )}
        </Box>
        {offlineCount > 0 && (
          <Box
            display='inline-flex'
            alignItems='center'
            sx={{
              bgcolor: 'error.light',
              px: '4px',
              py: '3px',
              flexShrink: 0,
            }}
          >
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 600,
                color: 'error.dark',
                lineHeight: 'normal',
                whiteSpace: 'nowrap',
              }}
            >
              {offlineCount} Offline
            </Typography>
          </Box>
        )}
      </Box>

      {!isOthers && (
        <Button variant='contained' onClick={handleViewDetails}>
          View Details
        </Button>
      )}
    </>
  );
};
